import React from 'react';
import { Paper } from '@honeycomb/ui-core';
import { HotelReviewsHeader } from './HotelReviewsHeader/HotelReviewsHeader';
import { HotelReviewsList } from './HotelReviewsList/HotelReviewsList';
export function HotelReviewsPageSection({ hotelDetails, onDialogTriggerClick, }) {
    const { customerFeedback } = hotelDetails;
    if (!customerFeedback) {
        return null;
    }
    return (React.createElement(Paper, { py: 5, defaultGutters: true },
        React.createElement(HotelReviewsHeader, { hotelDetails: hotelDetails, onDialogTriggerClick: onDialogTriggerClick, mb: 6 }),
        React.createElement(HotelReviewsList, { hotelDetails: hotelDetails })));
}
